import React from 'react';
import Svg from '../Svg';
import { SvgProps } from '../types';

const Icon: React.FC<SvgProps> = props => (
  <Svg viewBox="0 0 23 23" {...props}>
    <path d="M11.5 14.2864C16.7696 14.2864 21.2491 17.6726 22.8878 22.3834L23 22.7221H0C1.53807 17.8357 6.10494 14.2864 11.5 14.2864ZM18.2793 0.0415039V6.82082C18.2793 10.5595 15.2505 13.6001 11.5 13.6001C7.74949 13.6001 4.72068 10.5713 4.72068 6.82082C4.72068 3.28327 7.43004 0.37278 10.8848 0.0651667L11.2042 0.0415039H18.2793ZM14.0174 9.04361C13.7587 8.7741 13.3304 8.76536 13.0609 9.02409C12.4233 9.6362 11.895 9.91797 11.5 9.91797C11.105 9.91797 10.5767 9.6362 9.93906 9.02409C9.66955 8.76536 9.24132 8.7741 8.98259 9.04361C8.72386 9.31313 8.7326 9.74136 9.00211 10.0001C9.86777 10.8311 10.6924 11.2709 11.5 11.2709C12.3076 11.2709 13.1322 10.8311 13.9979 10.0001C14.2674 9.74136 14.2761 9.31313 14.0174 9.04361Z" />
  </Svg>
);

export default Icon;
